var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"std-background-blue-2 std-border-radius\nstd-pointer card-container d-flex align-center\nfont-weight-medium justify-center unselectable std-text-white-1"},[_vm._v("\n  "+_vm._s(_vm.text)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }